import { render, staticRenderFns } from "./OtherBenefits.vue?vue&type=template&id=23c3eecc"
import script from "./OtherBenefits.vue?vue&type=script&lang=js"
export * from "./OtherBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports